import { Capacitor } from "@capacitor/core";

/**
 * Requests an in-app review/rating prompt.
 * On native platforms, triggers the native app store review dialog.
 * On web, this is a no-op.
 *
 * Note: The native review dialog may not always appear - the OS controls
 * when and how often to show it based on its own heuristics.
 */
export async function requestInAppReview(): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  const { InAppReview } = await import("@capacitor-community/in-app-review");
  await InAppReview.requestReview();
}
